import { track } from '../../analytics/events';

export const desktopAnalytics = () => ({
  // top level click events
  click: {
    continue: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
  view: {
    offerImpressed: (
      accountId,
      adGroupId,
      adId,
      id,
    ) => track('ImpressionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId: id,
      },
    }),
  },
  offersModal: {
    opened: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'MODAL_OPENED',
    }),
    closed: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'X',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    continue: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    selectMoreOffers: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Select More Offers',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    print: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Print them now',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    text: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Text them',
      },
      actionOutcome: 'Expand',
    }),
    phoneNumberField: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'Phone',
        fieldName: 'phone',
        fieldLabel: 'Mobile Phone Number',
      },
      formContent: {
        formName: 'SEND_OFFERS',
      },
    }),
    sendOffers: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Send Offers',
      },
      actionOutcome: 'Submit',
    }),
    selectedOffers: (
      accountId,
      adGroupId,
      adId,
      templateId,
    ) => track('selectionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId,
      },
    }),
  },
});

export const mobileAnalytics = () => ({
  click: {
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
  view: {
    offerImpressed: (
      accountId,
      adGroupId,
      adId,
      id,
    ) => track('ImpressionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId: id,
      },
    }),
  },
  offersModal: {
    opened: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'MODAL_OPENED',
    }),
    closed: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'X',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    no: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'No',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    phoneNumberField: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'Phone',
        fieldName: 'phone',
        fieldLabel: 'Mobile Phone Number',
      },
      formContent: {
        formName: 'SEND_OFFERS',
      },
    }),
    sendOffers: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Yes, Send Offers',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    selectedOffers: (
      accountId,
      adGroupId,
      adId,
      templateId,
    ) => track('selectionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId,
      },
    }),
  },
});
